import React from 'react';
import { SideNavLink } from 'carbon-components-react/lib/components/UIShell';
import { ChevronLeft16, ChevronRight16 } from '@carbon/icons-react';

interface Props {
  isExpanded: boolean;
  toggleShowHide: () => void;
}

export const LeftNavShowHideMenu: React.FC<Props> = ({
  isExpanded,
  toggleShowHide
}) => {
  return (
    <>
      <div className="divider" />
      <SideNavLink
        renderIcon={isExpanded ? ChevronRight16 : ChevronLeft16}
        onClick={toggleShowHide}
      >
        Hide menu
      </SideNavLink>
    </>
  );
};

export default LeftNavShowHideMenu;
